<template>
    <div class="col-md-12" style="overflow : auto">
        <br />
        <b-tabs>
            <br />
            <b-tab title="Documents">
                <Documents />
            </b-tab>
            <b-tab title="Profiles">
                <Profiles />
            </b-tab>
        </b-tabs>
    </div>
</template>
<script>
    import Documents from "./DocumentsDownloads.vue";
    import Profiles from "./ProfileDownloads.vue";
    export default{
        components: {
            Documents,
            Profiles
        },
    };
</script>